"use client";

import type { Locale } from "@i18n/react";
import { useSearchParams } from "next/navigation";

import { usePathname, useRouter } from "../lib/navigation";

export const useSetLocale = () => {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  const setLocale = ({ locale }: { locale: Locale }) =>
    router.push(`${pathname}?${searchParams.toString()}`, { locale });

  return { setLocale };
};
